// extracted by mini-css-extract-plugin
export default {"audioPlayer":"AudioPlayer_audioPlayer__nDWQf"};